export const disableHistoryRoutes = [
  "/orders",
  "/mainnews",
  "/ether-orders",
  "/history",
  "/dashboard",
  "/order",
];
